import { render, staticRenderFns } from "./SimpleFormD.vue?vue&type=template&id=6f9acc8a&scoped=true&"
import script from "./SimpleFormD.vue?vue&type=script&lang=ts&"
export * from "./SimpleFormD.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleFormD.vue?vue&type=style&index=0&id=6f9acc8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9acc8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/2/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VScaleTransition } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VContainer,VFlex,VForm,VLayout,VScaleTransition,VTextField})
